var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"room__rm-files rm-files"},[_c('h2',{staticClass:"rm-files__title r-title"},[_vm._v("Рецепт")]),_vm._v(" "),_c('recept'),_vm._v(" "),_c('recept-manage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }